module.exports = __webpack_public_path__ + "0696106b73c07e9820d993481c93b84a.svg";